import { h } from "@sanity/block-content-to-html"
import { ClientConfig, createClient } from "@sanity/client"
import imageUrlBuilder from "@sanity/image-url"

export const sanityOptions = {
  projectId: "5qrdd1a6",
  dataset: "production",
  apiVersion: new Date().toISOString().slice(0, 10),
  fetch: fetch,
}

const client = createClient({
  ...sanityOptions,
  useCdn: true,
} as ClientConfig)

const previewClient = createClient({
  ...sanityOptions,
  useCdn: false,
  withCredentials: true,
  token: process.env.NEXT_PUBLIC_SANITY_TOKEN,
} as ClientConfig)

export function getSanityClient(preview = false) {
  if (preview || process.env.NEXT_PUBLIC_VERCEL_ENV === "development") {
    return previewClient
  }
  return client
}

const builder = imageUrlBuilder(sanityOptions)

export function urlFor(source) {
  return builder.image(source)
}

export const getDrafts = (docs: any[], preview = false) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === "development" || preview) {
    const drafts = docs.filter((doc) => doc._id.startsWith("drafts."))
    return drafts.length ? drafts : docs
  }
  return docs
}
type Dimensions = { width: number; height: number }
export function resizeDimensions(width: number, dimensions: Dimensions) {
  const percentage = (width * 100) / dimensions.width / 100
  return {
    width: Math.round(dimensions.width * percentage),
    height: Math.round(dimensions.height * percentage),
  }
}

export const serializers = {
  marks: {
    link: (props) =>
      h(
        "a",
        {
          href: props.mark.href,
          target: props.mark.blank ? "_blank" : "",
        },
        props.children,
      ),
  },
}
